import produce from 'immer'
import { LoginResult } from 'types'
import { CustomerActionTypes, LOGIN_RESULT, LoginResultPayload, LOGOUT, UPDATE_IDENTIFIER } from './types'

type CustomerIdentifier = string

const initialState = {
  loginResult: {} as LoginResult,
  identifier: '' as CustomerIdentifier,
}

type CustomerInitialState = typeof initialState

export function customerReducer(state: CustomerInitialState = initialState, action: CustomerActionTypes) {
  return produce(state, draft => {
    switch (action.type) {
      case LOGIN_RESULT:
        const result = action.payload as LoginResultPayload
        draft.loginResult = result.loginResult
        draft.identifier = result.loginResult.user.identifier
        return draft
      case LOGOUT:
        draft.loginResult = {} as LoginResult
        draft.identifier = ''
        return draft
      case UPDATE_IDENTIFIER:
        draft.identifier = action.payload
        return draft
      default:
        return state
    }
  })
}
